import { NgModule } from '@angular/core';
import { AccredibleFontService } from './font.service';

@NgModule({
  providers: [AccredibleFontService],
})
export class AccredibleFontServiceModule {}
